import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static values = {
    href: String,
    disabledClass: String
  }

  enable = () => {
    this.element.setAttribute('href', this.hrefValue)
    this.element.classList.remove(this.disabledClassValue)
  }

  disable = () => {
    this.element.removeAttribute('href')
    this.element.classList.add(this.disabledClassValue)
  }

  setContent = (e) => {
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = e.detail.content
    } else {
      this.element.innerHTML = e.detail.content
    }
  }
}
